// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29N5x","index":"styles_index__2hU41"};